import { useFetch } from 'hooks/useFetch';
import { ChildForm, SchemaDB } from 'interfaces/schemaDB';
import React, { useEffect, useReducer, useState } from 'react'
import { SchemaDBContext } from './schemaDBContext';
import { nanoid } from 'nanoid'
import { TableDB } from '../../../src/interfaces/schemaDB';
// import data from './schema.json'

//los children del Todo provider pueden ser uno o varios, pues
//dentro de él pueden ir muchas cosas (Ver el Todo.tsx)
//los elementos que van dentro de SchemaDBProvider son elemntos JSX, por eso se declaraan así
interface props{
    children: JSX.Element | JSX.Element[]
}


const SchemaDBProvider = ({children}: props) => {
    
    const id = nanoid()
    const [schemaDBState,  setSchemaDBState]  = useState<SchemaDB>({tables: []})
    const [childrenTables, setChildrenTables] = useState<ChildForm[]>([])

    useEffect(() => {
        loadSchemas();
    }, [])

    async function loadSchemas() {
        const folder = '/schemas';
        const files = [
            'publication.json',
            'bibliotecaVirtual.json',
            'autorPublication.json',
            'autorSectionPublication.json',
            'subsectionPub.json',
            'fragmentPub.json',
            'sectionPub.json',
            'fragmentObject.json',
            'infografia.json',
            'seccionInfografia.json',
            'subSeccionInfografia.json',
            'slideInfografia.json',
            'subSlideInfografia.json',
            'fragmentType.json',
            'recursoInfografia.json',
            'contentRelInfo.json',
            'trivia.json',
            'dialogo.json',
            'templateInfografia.json',
            'copyRight.json',
            'autorXDocumento.json'
        ];
    
        const schemas = await Promise.all(
            files.map(async file => {
                const response = await fetch(`${folder}/${file}`);
                return response.json();
            })
        );
    

        setSchemaDBState({ tables: schemas });
    }

    function setCurrentChildrenTables(tables:ChildForm[]){
        setChildrenTables(tables)
    }


    // function addTableSchema(table: TableDB | undefined){

    //     const setData = async(table: TableDB ) => {
    //         const schemaTmp : SchemaDB = {tables: schemaDBState.tables.concat(table)}
    //         setSchemaDBState( schemaTmp )
    //     }
    //     if(table){
    //         const tempDB : SchemaDB ={tables:[table]}
    //         setData( table )
    //     }
    // }

    return (
        <SchemaDBContext.Provider value={{
            schemaDBState
            , setSchemaDBState
            , childrenTables
            , setCurrentChildrenTables
            // , addTableSchema
        }}>
            {children}
        </SchemaDBContext.Provider>
    )
}

export default SchemaDBProvider
